<a id="toCart" [routerLink]="{ cxRoute: 'cart' } | cxUrl">
  <span class="valio-icon icon-cart"></span>
  <span class="count">{{ quantity$ | async }}</span>
  <span class="cart-text">{{ 'cart.header.cart' | cxTranslate }}</span>
</a>
